import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, BehaviorSubject, of, throwError } from 'rxjs';
import { Constants } from 'src/app/shared/constants';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class CustomerService {
  constructor(private http: HttpClient) { }

  Baseurl(): string {
    return Constants.BASE_URL;
  }

  createCustomer(customer): any {
    return this.http.post<any>(this.Baseurl() + 'Masters/PostCustomer', customer, { observe: 'response' });
  }

 getCreditorAccounts(locationId: number): Observable<any> {
    return this.http.get<any>(this.Baseurl() + 'AccountMaster/GetCreditorAccounts/' + locationId);
  }

  getCustomers(locationId): Observable<any> {
    return this.http.get<any>(this.Baseurl() + 'Masters/GetCustomerList/'+locationId);
  }

  getCustomerListWithPagination(payload: { LocationID: number; offset: number; pagesize: number }): Observable<any> {
    return this.http.post<any>(this.Baseurl() + 'Masters/GetCustomerListWithPagination', payload, { observe: 'response' });
  }

  getState(): Observable<any> {
    return this.http.get<any>(this.Baseurl() + 'Masters/GetStateList');
  }

  addCostCenter(costCenter): any {
    return this.http.post<any>(this.Baseurl() + 'Masters/PostCustomerCostCenter', costCenter, { observe: 'response' });
  }

  getCostCenter(inpuData):  any {
    return this.http.post<any>(this.Baseurl() + 'Masters/GetCostCenterByCustomer', inpuData, { observe: 'response' });
  }
getPendingActivatedCustomers(locationId: number): Observable<any> {
  return this.http.get<any>(`${this.Baseurl()}Masters/GetPendingActivatedCustomers/${locationId}`, { observe: 'response' }).pipe(
    catchError((error) => {
      console.error('GetPendingActivatedCustomers API error:', error);
      return throwError(() => new Error(`Failed to fetch pending customers: ${error.message || 'Server error'}`));
    })
  );
}
  getAddressByPincode(pincode: string): Observable<any> {
    const payload = { SearchString: pincode };
    return this.http.post<any>(this.Baseurl() + 'Masters/GetAddressByPincode', payload, { observe: 'response' });
  }
  getCustomerByID(payload: { SearchID: number; LocationID: number }): Observable<any> {
    return this.http.post<any>(this.Baseurl() + 'Masters/GetCustomerByID', payload, { observe: 'response' }).pipe(
      catchError((error) => {
        console.error('Get customer by ID API error:', error);
        return throwError(() => new Error(`Failed to fetch customer by ID: ${error.message || 'Server error'}`));
      })
    );
  }
  searchCustomers(payload: { SearchString: string; LocationID: number }): Observable<any> {
    return this.http.post<any>(this.Baseurl() + 'Masters/GetCustomer', payload, { observe: 'response' }).pipe(
      catchError((error) => {
        console.error('Search customers API error:', error);
        return throwError(() => new Error(`Failed to search customers: ${error.message || 'Server error'}`));
      })
    );
  }
   searchCustomer(payload: { SearchString: string; LocationID: number }): Observable<any> {
    return this.http.post<any>(this.Baseurl() + 'Masters/GetCustomerList', payload, { observe: 'response' }).pipe(
      catchError((error) => {
        console.error('Search customers API error:', error);
        return throwError(() => new Error(`Failed to search customers: ${error.message || 'Server error'}`));
      })
    );
  }

}
